import styled from 'styled-components';

export const BlockchainTable = styled.div<{ $isLarge?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  gap: 20px;

  border: 1px solid var(--v3-black-2);
  border-radius: 16px;
  flex: none;
  order: 1;
  flex-grow: 0;
  a {
    padding: unset;
  }

  > div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;

    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    :first-child .ant-btn {
      padding-right: 0;
      border-radius: 0;
    }
    :not(:last-child) {
      border-bottom: 1px solid var(--v3-black-2);
      padding: 0 0 20px;
    }
    > div {
      margin: 0;
      font-weight: 500;
      font-size: ${props => (props.$isLarge ? 20 : 16)}px;
      line-height: ${props => (props.$isLarge ? 32 : 20)}px;
      :first-child {
        color: var(--v3-text-color-secondary);
      }
      :last-child {
        color: var(--v3-text-color);
      }
    }
  }
`;
